export default __webpack_public_path__ + "static/media/section-bg.c2402120.png";